__turbopack_context__.v({
  "footer": "HowLongView-module__y8_xFG__footer",
  "grid": "HowLongView-module__y8_xFG__grid",
});
